import React, { Component } from "react";
import { withRequest } from "../../../utils/request";
import { auth } from "../../../utils/auth";

class Form extends Component {
    state = {
        sucursales: []
    };

    componentDidMount() {
        this.getSucursales();
    }

    getSucursales = async (url = null) => {
        url = url ? url : "sucursales";
        const sucursales = await this.props.request(url);

        if (sucursales.data) {
            this.setState({
                sucursales: sucursales.data,
                loading: false
            });
        }
    };

    render() {
        const { usuario, errors } = this.props;
        const { sucursales } = this.state;
        return (
            <div>
                <div className='row form-group'>
                    <div className='col col-md-5'>
                        <label className='label form-control-label'>
                            Nombre de Usuario:
                        </label>
                    </div>
                    <div className='col col-md-7'>
                        <input
                            type='text'
                            className='text-input form-control'
                            id='username'
                            name='username'
                            defaultValue={usuario.usuario}
                        />
                        {errors.username && (
                            <small className='help-blockParams form-Text'>
                                {errors.username[0]}
                            </small>
                        )}
                    </div>
                </div>
                <div className='row form-group'>
                    <div className='col col-md-5'>
                        <label className='label form-control-label'>
                            Nombre:
                        </label>
                    </div>
                    <div className='col-md-7'>
                        <input
                            type='text'
                            className='text-input form-control'
                            id='nombre'
                            name='nombre'
                            defaultValue={usuario.nombre}
                        />
                        {errors.nombre && (
                            <small className='help-blockParams form-Text'>
                                {errors.nombre[0]}
                            </small>
                        )}
                    </div>
                </div>
                <div className='row form-group'>
                    <div className='col col-md-5'>
                        <label className='label form-control-label'>
                            Apellido:
                        </label>
                    </div>
                    <div className='col-md-7'>
                        <input
                            type='text'
                            className='text-input form-control'
                            id='apellido'
                            name='apellido'
                            defaultValue={usuario.apellido}
                        />
                        {errors.apellido && (
                            <small className='help-blockParams form-Text'>
                                {errors.apellido[0]}
                            </small>
                        )}
                    </div>
                </div>
                <div className='row form-group'>
                    <div className='col col-md-5'>
                        <label className='label form-control-label'>
                            Email
                        </label>
                    </div>
                    <div className='col-md-7'>
                        <input
                            type='email'
                            className='text-input form-control'
                            id='email'
                            name='email'
                            defaultValue={usuario.email}
                        />
                        {errors.email && (
                            <small className='help-blockParams form-Text'>
                                {errors.email[0]}
                            </small>
                        )}
                    </div>
                </div>
                <div className='row form-group'>
                    <div className='col col-md-5'>
                        <label className='label form-control-label'>Rol</label>
                    </div>
                    <div className='col-md-7'>
                        <select
                            className='text-input form-control'
                            id='role'
                            defaultValue={usuario.rol}
                            name='role'>
                            <option value='rrhh'>RRHH</option>
                            <option value='admin'>Admin</option>
                            <option value='digitador'>Digitador</option>
                            <option value='gasto'>Gasto</option>
                            {auth.is("super-admin") && (
                                <option value='super-admin'>Super Admin</option>
                            )}
                        </select>
                        {errors.role && (
                            <small className='help-blockParams form-Text'>
                                {errors.role[0]}
                            </small>
                        )}
                    </div>
                </div>
                <div className='row form-group'>
                    <div className='col col-md-5'>
                        <label className='label form-control-label'>
                            Activo
                        </label>
                    </div>
                    <div className='col-md-7'>
                        <label className='switch switch-3d switch-success mr-3'>
                            <input
                                key={usuario.id}
                                type='checkbox'
                                className='switch-input'
                                id='active'
                                name='active'
                                value='yes'
                                defaultChecked={usuario.estado ? true : false}
                            />
                            <span className='switch-label' />
                            <span className='switch-handle' />
                        </label>
                    </div>
                </div>

                <div className='row form-group'>
                    <div className='col col-md-5'>
                        <label className='label form-control-label'>
                            Sucursales
                        </label>
                    </div>
                    <div className='col-md-7 row'>
                        {sucursales.map(sucursal => {
                            let sucursalesUsuario = [];
                            if (usuario.sucursales) {
                                sucursalesUsuario = usuario.sucursales.map(
                                    suc => suc.id
                                );
                            }
                            return (
                                <div className='col-md-6' key={sucursal.id}>
                                    <div className='checkbox'>
                                        <label className='form-check-label '>
                                            <input
                                                type='checkbox'
                                                name='sucursales[]'
                                                defaultChecked={
                                                    sucursalesUsuario.indexOf(
                                                        sucursal.id
                                                    ) > -1
                                                }
                                                value={sucursal.id}
                                                className='form-check-input'
                                            />
                                            {sucursal.nombre}
                                        </label>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </div>

                <div className='row form-group'>
                    <div className='col col-md-5'>
                        <label className='label form-control-label'>
                            Contraseña
                        </label>
                    </div>
                    <div className='col-md-7'>
                        <input
                            type='password'
                            className='text-input form-control'
                            id='password'
                            name='password'
                        />
                        {errors.password && (
                            <small className='help-blockParams form-Text'>
                                {errors.password[0]}
                            </small>
                        )}
                    </div>
                </div>
                <div className='row form-group'>
                    <div className='col col-md-5'>
                        <label className='label form-control-label'>
                            Confirmar Contraseña
                        </label>
                    </div>
                    <div className='col-md-7'>
                        <input
                            type='password'
                            className='text-input form-control'
                            id='password_confirmation'
                            name='password_confirmation'
                        />
                    </div>
                </div>
            </div>
        );
    }
}

export default withRequest(Form);
